(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2163],{

/***/ 8814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1373);
/**
 * @license lucide-react v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const ChevronLeft = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);


//# sourceMappingURL=chevron-left.js.map


/***/ }),

/***/ 6983:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-strategy-for-business",
      function () {
        return __webpack_require__(5200);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3193);
/* harmony import */ var _components_homepage_ContactUsHome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6245);
/* harmony import */ var _components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4837);
/* harmony import */ var _components_reusable_BlogSlider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1294);










var Navbar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2684), __webpack_require__.e(7804), __webpack_require__.e(1352)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});
/* ─── data ──────────────────────────────────────────────── */ var industryIntelligence = [
    {
        name: "Banking & Financial Services",
        link: "/industry/banking",
        examples: [
            {
                company: "JPMorgan",
                description: "Deployed LLM Suite to 50,000+ employees across investment banking and wealth management — contract analysis, research summarisation, and compliance review. Cited by CEO Jamie Dimon in shareholder letters as one of the most extensive enterprise LLM deployments in financial services."
            },
            {
                company: "Klarna",
                description: "AI assistant handles the equivalent workload of 700 full-time customer service agents. Handled two-thirds of all customer service chats in its first month — February 2024 public announcement."
            },
            {
                company: "Morgan Stanley",
                description: "AI-powered wealth management assistant deployed to 16,000+ financial advisors, built with OpenAI. Provides instant access to research, product information, and compliance documentation during client calls."
            }, 
        ],
        itmtbPattern: "Mid-market Indian banks: RBI Digital Lending compliance monitoring agents, vernacular customer support agents, fraud detection on transaction streams. Regulatory architecture is co-designed from the first sprint."
    },
    {
        name: "Insurance",
        link: "/industry/insurance",
        examples: [
            {
                company: "Lemonade",
                description: "AI handles straightforward claims end-to-end — document review, fraud check, settlement — in seconds. Extensively documented in their S-1 and earnings calls as a core operational differentiator."
            },
            {
                company: "Tractable",
                description: "Computer vision for vehicle damage assessment from photographs, used by global insurers to replace manual adjusters on standard claims. Sub-minute assessment on clear-image submissions."
            },
            {
                company: "Global Tier-1 insurers",
                description: "AI-assisted underwriting decision support is in production at multiple Tier-1 insurers in Europe and North America — reviewing risk signals, flagging edge cases, and preparing recommendations for human underwriters while maintaining regulatory sign-off."
            }, 
        ],
        itmtbPattern: "Indian insurance: IRDAI-compliant underwriting decision support, IIB data reporting agents, claims automation. The compliance posture document is the first deliverable of the architecture sprint."
    },
    {
        name: "Life Sciences & Pharma",
        link: "/industry/life-sciences",
        examples: [
            {
                company: "Pfizer",
                description: "PfizerGPT — internal LLM deployment for research summarisation, clinical document review, and scientific literature analysis. Deployed across R&D and regulatory functions, announced 2023."
            },
            {
                company: "Recursion Pharmaceuticals",
                description: "AI-native drug discovery company (NASDAQ: RXRX). Foundation models trained on biological data identify novel drug targets — compressing discovery timelines that traditionally run 5–10 years."
            },
            {
                company: "Insilico Medicine",
                description: "A generative AI system designed novel drug candidate INS018_055 for idiopathic pulmonary fibrosis. Entered Phase II clinical trials — the first AI-designed drug candidate to reach this milestone (published in Nature Biotechnology)."
            }, 
        ],
        itmtbPattern: "Pharma and CROs: formulation assistants built for CDSCO and FDA 21 CFR Part 11 audit-trail requirements, regulatory document automation, R&D literature agents. Compliance architecture is co-designed with regulatory counsel."
    },
    {
        name: "Retail, D2C & Quick Commerce",
        link: "/industry/retail",
        examples: [
            {
                company: "Walmart",
                description: "Multiple AI deployments across supplier negotiation agents, in-app shopping assistant, and store operations optimisation. Walmart has made AI a stated strategic priority with publicly documented investments across the retail stack."
            },
            {
                company: "Amazon",
                description: "Rufus — AI shopping assistant trained on Amazon's product catalogue, customer reviews, and community Q&A. Launched in the US in 2024. Handles product discovery, comparison, and decision support natively in the app."
            },
            {
                company: "Instacart",
                description: "Caper AI smart carts with on-device AI, plus AI-powered search and recipe-to-cart agents. Instacart has published extensively on their AI product roadmap including agentic shopping flows."
            }, 
        ],
        itmtbPattern: "Quick commerce and D2C: dark-store inventory rebalancing agents, demand-forecasting on 10-minute SKU windows, dynamic-pricing agents for hyperlocal demand. Integrates with existing WMS and POS systems."
    },
    {
        name: "Supply Chain & Logistics",
        link: "/industry/supply-chain",
        examples: [
            {
                company: "Maersk",
                description: "Extensive AI investments in container routing, predictive maintenance, and port operations optimisation — documented across investor materials, sustainability reports, and conference talks over 2022–2024."
            },
            {
                company: "DHL",
                description: "AI and robotics deployment across parcel sorting, predictive shipment risk, and last-mile optimisation. DHL Trend Research publishes annually on AI adoption progress across the logistics stack."
            },
            {
                company: "Flexport",
                description: "AI-powered freight orchestration — rate recommendations, documentation automation, and exception management. Flexport has positioned AI as a stated strategic differentiator in its platform and public communications."
            }, 
        ],
        itmtbPattern: "Our deployment: custom CNN for SKU identification across 100,000+ SKUs in 35 countries — 97% reduction in identification time, sub-3-minute lookup. Multi-site reconciliation agents and ERP integration (Dynamics 365, SAP) running in production."
    },
    {
        name: "Professional Services & Accounting",
        link: null,
        examples: [
            {
                company: "KPMG",
                description: "KPMG Clara — AI-powered audit platform used in live engagements. Analyses contract terms, flags anomalies in financial data, and surfaces audit risks. Deployed at scale across KPMG's global audit practice."
            },
            {
                company: "Harvey AI",
                description: "Legal AI used by Am Law 200 firms and Big 4 accounting practices for research, contract review, and regulatory analysis. One of the most widely adopted specialised legal AI systems in professional services."
            },
            {
                company: "EY",
                description: "EY.ai — enterprise AI platform announced in 2023 with a $1.4 billion investment. Deployed across audit, tax, and advisory practices for document analysis, research, and client-facing workflow automation."
            }, 
        ],
        itmtbPattern: "Mid-market professional services: month-end close reconciliation agents (GL ingestion → variance report), audit working-paper preparation, GST and international tax research agents. Pattern is typically agentic RAG over historical files and regulatory sources."
    }, 
];
var proofCases = [
    {
        label: "Supply chain",
        problem: "A global supply chain leader needed to identify 100,000+ SKUs across 35 countries without manual lookup — a process taking up to 3 weeks per reconciliation cycle.",
        approach: "Architecture sprint identified a custom CNN with a serverless inference layer as the right pattern. Data pipeline scoped, compliance posture mapped, edge cases documented before a line of build code was written.",
        outcome: "97% reduction in SKU identification time. Sub-3-minute lookup per item across 35 countries. Running in production.",
        link: "/industry/supply-chain"
    },
    {
        label: "Risk intelligence",
        problem: "A global intelligence and risk consulting firm needed to compress 3-day third-party risk analyses — document discovery, financial review, regulatory checks, synthesis — without adding headcount.",
        approach: "Architecture sprint determined four specialised AI models in orchestration was the correct pattern. Each model handles one domain; outputs synthesised by a final reasoning layer.",
        outcome: "Analyses that took 3 days now complete in under 1 hour with minimal human input. Running in production.",
        link: "/blog/business-intelligence-ai-strategy"
    },
    {
        label: "Managed services",
        problem: "ITMTB needed to scale its own managed services operation without linear headcount growth. Incident triage and routine remediation were the primary bottlenecks.",
        approach: "Architecture sprint mapped 40+ incident categories and remediation patterns. Orchestrik agents built to triage, execute routine remediations, and escalate with full context.",
        outcome: "Technology support effort reduced by over 90%. Orchestrik now operates as a standalone AI operations platform.",
        link: "/orchestrik",
        external: false
    }, 
];
var deliverables = [
    {
        number: "01",
        title: "AI opportunity map",
        body: "Every workflow candidate scored on ROI potential \xd7 implementation feasibility \xd7 regulatory risk. Ranked. Scored against your specific business model and tech stack — not a generic framework."
    },
    {
        number: "02",
        title: "Priority workflow shortlist",
        body: "The 3–5 workflows with the best risk-adjusted return and the clearest implementation path. Each entry includes: data requirements, integration surface, agent pattern, and estimated production timeline."
    },
    {
        number: "03",
        title: "Build / buy / partner recommendation",
        body: "Per workflow: should you build custom, configure an existing platform, or partner for a specific capability? We have no platform to sell. The recommendation is independent."
    },
    {
        number: "04",
        title: "90-day pilot scope",
        body: "A scoped, de-risked first phase you can hand to engineering — or to us. Bounded objective, defined success metrics, go/no-go checkpoint. A plan engineering can actually execute, not a vague roadmap."
    }, 
];
var differentiators = [
    {
        claim: "We own the build risk if you continue with us",
        detail: "When the diagnostic produces a pilot scope and you choose to engage us for the build, we carry the delivery risk. One team from diagnostic to production — not a handoff to a separate team who never read the strategy document."
    },
    {
        claim: "Recommendations are technically vetted, not abstract",
        detail: "Every roadmap item is validated against real integration surfaces — your ERP, your data infrastructure, your existing APIs. Recommendations that cannot survive contact with your tech stack do not go in the document."
    },
    {
        claim: "We have shipped the patterns we recommend",
        detail: "The agent workflows we recommend are ones we have built in production — not patterns from a Gartner report. If we recommend multi-agent orchestration for your risk reporting, it is because we have shipped one."
    }, 
];
var governanceAnchors = [
    {
        title: "Regulatory posture (India)",
        body: "RBI Digital Lending, SEBI, IRDAI, IIB, DPDP consent, CDSCO / FDA 21 CFR Part 11 — documented and designed into your AI architecture from the first sprint, not retrofitted."
    },
    {
        title: "Model risk management",
        body: "Every recommended AI system includes: non-determinism monitoring, audit trail requirements, escalation paths, and acceptable-outcome distributions for regulated decisions."
    },
    {
        title: "Vendor lock-in",
        body: "We surface lock-in risk in every build / buy / partner recommendation. Where vendor dependencies are unavoidable, we document the exit path and portability of your data and models."
    }, 
];
var faqItems = [
    {
        question: "How long does an AI strategy engagement take?",
        answer: "The core diagnostic is two weeks, fixed-price. Week one: a focused executive session, workflow interviews, and technical environment review. Week two: analysis, scoring, and deliverable preparation. You receive four deliverables at the end of week two. If you proceed to a production build, the architecture sprint and build timeline follow immediately — no context reset."
    },
    {
        question: "What does an AI roadmap actually contain?",
        answer: "Our roadmap is four documents, not a slide deck: (1) an AI opportunity map with every workflow candidate scored on ROI \xd7 feasibility \xd7 regulatory risk; (2) a priority shortlist with data requirements and integration notes per workflow; (3) a build / buy / partner recommendation per workflow; (4) a 90-day pilot scope for the top priority — objective, success metrics, go/no-go checkpoint, and estimated cost. Total: 15–30 pages, no filler."
    },
    {
        question: "How do we measure AI ROI before building anything?",
        answer: "We measure against two axes: time and cost saved on the current workflow (labour hours, error rate, cycle time), and revenue or margin impact enabled (faster decisions, better pricing, higher conversion). The baseline is your current workflow cost; the projection is the post-agent workflow cost plus implementation cost amortised over 24 months. We do not use vanity metrics — AI adoption rate or model accuracy in isolation tell you nothing about business impact."
    },
    {
        question: "Build vs buy: when does each make sense?",
        answer: "Buy when: the workflow is standard, the vendor has your regulatory context built in, and the integration surface is clean. Build when: the workflow is proprietary, the data is sensitive, the regulatory posture is complex, or the competitive advantage is in the process itself. We recommend build for workflows that touch proprietary data or regulated decisions in Indian financial services — generic platforms rarely carry RBI, IRDAI, or DPDP context out of the box."
    },
    {
        question: "How do we govern AI without slowing everything down?",
        answer: "Governance is scoped to risk, not applied uniformly. Low-risk, non-customer-facing agents (internal reconciliation, research summaries, document drafting) need lightweight review — audit trail and human spot-check. High-risk, regulated decisions (credit, claims, clinical) need formal model risk management: defined acceptable-outcome distributions, mandatory HITL, rollback paths, and regulator-ready audit trails. We document the governance posture per workflow in the diagnostic."
    },
    {
        question: "What if our data is not ready for AI?",
        answer: "Most organisations have better data than they think — and worse data hygiene than they realise. The diagnostic includes a data readiness assessment per workflow candidate. Where data is insufficient, we document what is needed — not a multi-year data lake project, usually a targeted 90-day cleanup on a specific domain. We will not recommend building an agent on a workflow where the data cannot support it. That is how agent projects fail."
    },
    {
        question: "What is a realistic pilot timeline?",
        answer: "A bounded pilot — one workflow, one agent pattern, one integration — typically runs 6–10 weeks from the end of the architecture sprint. This produces a working production agent, not a demo. Success metrics are defined before build starts; the go/no-go checkpoint is at week 4. If the pilot does not meet its metric, we surface the reasons and the options — not a project extension and a new invoice."
    },
    {
        question: "How do we manage AI change in a large organisation?",
        answer: "AI change management fails when treated as a communications exercise. We address it as an organisational design problem: who owns the agent's outputs, what happens when it is wrong, how errors are corrected, and what the agent replaces versus augments. The diagnostic includes a change management brief per priority workflow — roles, escalation paths, training requirements, and the rollback plan if adoption stalls."
    }, 
];
var relatedPosts = [
    {
        title: "Agentic AI vs Automation — A CXO's Guide",
        slug: "agentic-ai-vs-automation",
        img: "/blogImages/hero/agentic-ai-vs-automation.webp"
    },
    {
        title: "What Decision Makers Should Know About Agentic AI in 2025",
        slug: "what-decision-makers-should-know-about-agentic-ai-in-2025",
        img: "/blogImages/hero/decision-makers-2025.webp"
    },
    {
        title: "Solution Architecture using Agentic AI",
        slug: "solution-architecture-using-agentic-ai",
        img: "/blogImages/hero/solution-architecture-agentic-ai.webp"
    },
    {
        title: "Agentic AI Pilot Success",
        slug: "agentic-ai-pilot-success",
        img: "/blogImages/hero/agentic-ai-pilot.webp"
    },
    {
        title: "Agentic AI in Hospitality: Use Cases & Impact",
        slug: "agentic-ai-hospitality",
        img: "/blogImages/hero/agentic-ai-hos.webp"
    },
    {
        title: "Unleashing Agentic AI: Supply Chain, Fintech and Pharma",
        slug: "unleashing-agentic-ai-transforming-supply-chain-fintech-and-pharma",
        img: "/blogImages/hero/Unleashing-Agentic-AI-Transforming-Supply-Chain-Fintech-and-Pharma.webp"
    }, 
];
/* ─── schema ─────────────────────────────────────────────── */ var schemaGraph = [
    {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
            {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://www.itmtb.com"
            },
            {
                "@type": "ListItem",
                position: 2,
                name: "AI Strategy for Business",
                item: "https://www.itmtb.com/ai-strategy-for-business"
            }, 
        ]
    },
    {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "@id": "https://www.itmtb.com/ai-strategy-for-business#webpage",
        url: "https://www.itmtb.com/ai-strategy-for-business",
        name: "AI Strategy for Business | ITMTB",
        description: "ITMTB delivers AI strategy for business leaders — a two-week executive diagnostic, an AI opportunity map ranked by ROI, and an optional path to production build. For CEOs and executives scoping their AI roadmap.",
        publisher: {
            "@type": "Organization",
            name: "ITMTB",
            url: "https://www.itmtb.com",
            logo: {
                "@type": "ImageObject",
                url: "https://www.itmtb.com/logo.png"
            },
            sameAs: [
                "https://www.linkedin.com/company/itmtb/",
                "https://twitter.com/ItmtbT"
            ]
        },
        mainEntity: {
            "@type": "Service",
            name: "AI Strategy for Business",
            provider: {
                "@type": "Organization",
                name: "ITMTB",
                url: "https://www.itmtb.com"
            },
            areaServed: {
                "@type": "Place",
                name: "India and Global"
            },
            serviceType: "AI Strategy Consulting and Executive Diagnostic"
        }
    },
    {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqItems.map(function(item) {
            return {
                "@type": "Question",
                name: item.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: item.answer
                }
            };
        })
    }, 
];
/* ─── sub-components ─────────────────────────────────────── */ var SectionEyebrow = function(param) {
    var label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: "text-amber-700 text-xs font-semibold uppercase tracking-widest mb-3",
        children: label
    });
};
var FaqAccordion = function(param) {
    var items = param.items;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), open = ref[0], setOpen = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: items.map(function(item, i) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "border-b border-slate-200",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            return setOpen(open === i ? null : i);
                        },
                        className: "w-full flex justify-between items-start gap-4 text-left py-5 focus:outline-none group",
                        "aria-expanded": open === i,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-base font-semibold text-slate-900 leading-snug",
                                children: item.question
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "flex-shrink-0 text-slate-400 group-hover:text-slate-600 transition-colors text-xl leading-none mt-0.5",
                                children: open === i ? "−" : "+"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "pb-5 ".concat(open === i ? "block" : "hidden"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-600 text-sm leading-relaxed",
                            children: item.answer
                        })
                    })
                ]
            }, i);
        })
    });
};
/* ─── hero illustration ──────────────────────────────────── */ var RoadmapSVG = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        viewBox: "0 0 440 360",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: "w-full max-w-md opacity-60",
        children: [
            (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Array(5)).map(function(_, row) {
                return (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(Array(7)).map(function(_, col) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                        cx: 30 + col * 64,
                        cy: 40 + row * 68,
                        r: "1.5",
                        fill: "#292116"
                    }, "".concat(row, "-").concat(col));
                });
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 380 180 A 80 80 0 0 0 300 100",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 380 180 A 140 140 0 0 0 240 40",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 380 180 A 200 200 0 0 0 180 0",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M 60 280 C 100 260 130 240 160 220 C 200 195 220 185 260 175 C 300 165 330 162 380 160",
                stroke: "#475569",
                strokeWidth: "1.5",
                strokeDasharray: "4 3"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "80",
                cy: "272",
                r: "22",
                stroke: "#334155",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "80",
                cy: "272",
                r: "8",
                stroke: "#334155",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "220",
                cy: "188",
                r: "22",
                stroke: "#475569",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "220",
                cy: "188",
                r: "8",
                stroke: "#475569",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "360",
                cy: "158",
                r: "28",
                stroke: "#d97706",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "360",
                cy: "158",
                r: "12",
                stroke: "#d97706",
                strokeWidth: "1.5",
                strokeOpacity: "0.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                cx: "360",
                cy: "158",
                r: "4",
                fill: "#d97706",
                fillOpacity: "0.6"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "80",
                y1: "246",
                x2: "80",
                y2: "238",
                stroke: "#334155",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "220",
                y1: "162",
                x2: "220",
                y2: "154",
                stroke: "#475569",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "360",
                y1: "126",
                x2: "360",
                y2: "116",
                stroke: "#d97706",
                strokeWidth: "1.5"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "106",
                y1: "260",
                x2: "150",
                y2: "240",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "106",
                y1: "272",
                x2: "155",
                y2: "272",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "246",
                y1: "176",
                x2: "290",
                y2: "162",
                stroke: "#292116",
                strokeWidth: "1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "246",
                y1: "188",
                x2: "295",
                y2: "188",
                stroke: "#292116",
                strokeWidth: "1"
            })
        ]
    });
};
/* ─── page ───────────────────────────────────────────────── */ var AIStrategyPage = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(0), openIndustry = ref[0], setOpenIndustry = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-screen bg-white text-slate-900",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_3___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "AI Strategy for Business | ITMTB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "ITMTB delivers AI strategy for business leaders — a two-week executive diagnostic, an AI opportunity map ranked by ROI, and an optional path to production build. For CEOs and executives scoping their AI roadmap."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "ai strategy for business, enterprise ai strategy consulting, ai transformation consulting, ai roadmap, ai consulting company india, ai opportunity assessment, enterprise ai roadmap, ai advisory"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "AI Strategy for Business | ITMTB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Two-week executive diagnostic + AI opportunity map for business leaders. Written by people who ship the agents — not a generic strategy deck."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://www.itmtb.com/logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.itmtb.com/ai-strategy-for-business"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "AI Strategy for Business | ITMTB"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "AI strategy for executives — two-week diagnostic, opportunity map, 90-day pilot scope. ITMTB."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://www.itmtb.com/logo.png"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.itmtb.com/ai-strategy-for-business"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify(schemaGraph)
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-[#1a110a] text-white px-6 pt-36 pb-28",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto flex flex-col lg:flex-row lg:items-center lg:gap-16",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "lg:flex-1",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "AI strategy for business"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                    className: "text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.06] tracking-tight mb-6 max-w-3xl",
                                    children: [
                                        "AI strategy written by people",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {
                                            className: "hidden sm:block"
                                        }),
                                        " who ship the agents."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-lg sm:text-xl text-slate-400 leading-relaxed mb-4 max-w-2xl",
                                    children: "Two-week executive diagnostic. An AI opportunity map ranked by ROI. A 90-day pilot scope you can hand to engineering. And if you want, we build it too."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-base text-slate-500 mb-10 max-w-xl",
                                    children: "For CEOs, COOs, and CXOs who need a roadmap that survives contact with engineering."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex flex-col sm:flex-row gap-3",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/contact-us",
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "inline-block bg-white text-slate-900 hover:bg-slate-100 px-7 py-3.5 text-sm font-semibold rounded tracking-wide transition-colors",
                                                children: "Book the diagnostic"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "#industry-intelligence",
                                            className: "inline-block border border-slate-700 text-slate-300 hover:border-slate-500 hover:text-white px-7 py-3.5 text-sm font-semibold rounded tracking-wide transition-colors",
                                            children: "See what peers are deploying"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "hidden lg:flex lg:w-[420px] shrink-0 items-center justify-center mt-12 lg:mt-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RoadmapSVG, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-8 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ai_agent_demo_CustomerSection__WEBPACK_IMPORTED_MODULE_7__/* .CustomerSection */ .a, {
                    title: "Trusted by"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                            label: "The problem"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-10",
                            children: "Most AI strategy decks die on contact with engineering."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-8",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-3xl font-bold text-slate-200 flex-shrink-0 w-8 leading-none",
                                            children: "1"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-slate-900 mb-2",
                                                    children: "Advisors who don't build produce recommendations that don't ship."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-slate-600 leading-relaxed",
                                                    children: "The typical AI strategy engagement produces a roadmap that looks sound in a board deck and falls apart when engineering asks: where does this agent get its data, how does it connect to our ERP, and who handles the compliance review? Strategy advisors who have never shipped an agent in production cannot answer those questions."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-3xl font-bold text-slate-200 flex-shrink-0 w-8 leading-none",
                                            children: "2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-slate-900 mb-2",
                                                    children: "Build vendors who skip strategy produce agents that solve the wrong problem."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-slate-600 leading-relaxed",
                                                    children: "The typical custom AI build engagement starts with a brief, moves to a prototype, and delivers something technically functional that the business cannot adopt — because nobody mapped the workflow, the ownership, or the change management before the first line of code was written."
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-8",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-3xl font-bold text-slate-200 flex-shrink-0 w-8 leading-none",
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-slate-900 mb-2",
                                                    children: "ITMTB does both — in the same engagement, with the same team."
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-slate-600 leading-relaxed",
                                                    children: "Our diagnostic is written by engineers and architects who have shipped agentic AI in production — not by generalists with an AI toolkit. The roadmap we produce is technically validated before it leaves our hands. If you continue to the build, the same team carries the delivery risk."
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                id: "industry-intelligence",
                className: "bg-slate-50 py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-14",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "What your peers are deploying"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-3",
                                    children: "What industry leaders are doing with AI in 2025–2026"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "text-slate-600 text-base max-w-2xl",
                                    children: [
                                        "Named, public deployments — not generic case studies. Each section closes with the mid-market pattern we see in actual engagements. For the wider shifts these deployments sit inside, see",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/blog/technology-trends-india-2026",
                                            legacyBehavior: true,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "text-amber-700 font-medium hover:underline",
                                                children: "the eight technology shifts Indian enterprises should act on in 2026"
                                            })
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "border-t border-slate-200",
                            children: industryIntelligence.map(function(ind, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "border-b border-slate-200",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                            onClick: function() {
                                                return setOpenIndustry(openIndustry === i ? null : i);
                                            },
                                            className: "w-full flex justify-between items-center gap-4 text-left py-5 focus:outline-none group",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-sm font-bold text-slate-900 uppercase tracking-wide",
                                                    children: ind.name
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "flex-shrink-0 text-slate-400 group-hover:text-slate-600 transition-colors text-xl leading-none",
                                                    children: openIndustry === i ? "−" : "+"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "overflow-hidden transition-all duration-300 ease-in-out",
                                            style: {
                                                maxHeight: openIndustry === i ? "3000px" : "0px",
                                                opacity: openIndustry === i ? 1 : 0
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "pb-8 flex flex-col lg:flex-row gap-8 lg:gap-16",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "lg:w-52 flex-shrink-0",
                                                        children: ind.link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            href: ind.link,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: "text-xs font-medium text-slate-500 border-b border-transparent hover:border-slate-500 pb-px transition-colors uppercase tracking-wide",
                                                                children: "Our work in this sector"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex-1",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "space-y-5 mb-6",
                                                                children: ind.examples.map(function(ex) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                className: "text-sm font-semibold text-slate-900",
                                                                                children: [
                                                                                    ex.company,
                                                                                    " — "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                className: "text-sm text-slate-600 leading-relaxed",
                                                                                children: ex.description
                                                                            })
                                                                        ]
                                                                    }, ex.company);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "border-l-2 border-amber-700 pl-4 bg-white py-3 pr-4 rounded-r",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "text-xs font-semibold uppercase tracking-widest text-amber-700",
                                                                        children: "ITMTB pattern — "
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "text-xs text-slate-700 leading-relaxed",
                                                                        children: ind.itmtbPattern
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, ind.name);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "What we deliver"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-3",
                                    children: "What a two-week diagnostic produces"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-slate-600 text-base max-w-2xl",
                                    children: "Four documents, not a slide deck. Scored against your specific business model, tech stack, and regulatory posture."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-0",
                            children: deliverables.map(function(d, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-8 py-8 ".concat(i < deliverables.length - 1 ? "border-b border-slate-100" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-3xl font-bold text-slate-200 flex-shrink-0 w-12 leading-none",
                                            children: d.number
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-slate-900 mb-2",
                                                    children: d.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-slate-600 leading-relaxed max-w-2xl",
                                                    children: d.body
                                                })
                                            ]
                                        })
                                    ]
                                }, d.number);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-12 pt-8 border-t border-slate-100",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/itmtb-how-we-work",
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-sm font-medium text-slate-900 border-b border-transparent hover:border-slate-900 pb-px transition-colors",
                                    children: "Full methodology and engagement options"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-slate-50 py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "Why ITMTB"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-3",
                                    children: "Strategy from people who've shipped — not slideware."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-0",
                            children: differentiators.map(function(d, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex gap-8 py-8 ".concat(i < differentiators.length - 1 ? "border-b border-slate-200" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "w-2 h-2 rounded-full bg-slate-900 flex-shrink-0 mt-2"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    className: "text-base font-semibold text-slate-900 mb-2",
                                                    children: d.claim
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-sm text-slate-600 leading-relaxed max-w-2xl",
                                                    children: d.detail
                                                })
                                            ]
                                        })
                                    ]
                                }, d.claim);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "Proof"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-3",
                                    children: "Strategy that became code that shipped."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-slate-600 text-base max-w-2xl",
                                    children: "Three ITMTB engagements — each starting with a diagnostic, each shipping in production."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "space-y-0",
                            children: proofCases.map(function(c, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "py-10 ".concat(i < proofCases.length - 1 ? "border-b border-slate-100" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-xs font-semibold uppercase tracking-widest text-slate-500 mb-5",
                                            children: c.label
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xs uppercase tracking-widest text-slate-400 font-semibold mb-2",
                                                            children: "Problem"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-sm text-slate-600 leading-relaxed",
                                                            children: c.problem
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xs uppercase tracking-widest text-slate-400 font-semibold mb-2",
                                                            children: "Approach"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-sm text-slate-600 leading-relaxed",
                                                            children: c.approach
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-xs uppercase tracking-widest text-slate-400 font-semibold mb-2",
                                                            children: "Outcome"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-sm text-slate-900 font-medium leading-relaxed mb-3",
                                                            children: c.outcome
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            href: c.link,
                                                            legacyBehavior: true,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                className: "text-xs font-medium text-slate-900 border-b border-transparent hover:border-slate-900 pb-px transition-colors",
                                                                children: c.label === "Managed services" ? "See Orchestrik" : "Read more"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, c.label);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-white border-t border-b border-slate-200",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-6xl mx-auto px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-amber-700 text-xs font-semibold uppercase tracking-widest mb-1",
                                    children: "For a different intent"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-slate-900 text-lg font-semibold leading-snug",
                                    children: "Already know what to build?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-slate-500 text-sm mt-1",
                                    children: "Two-week architecture sprint → production agent build. No strategy track needed."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/agentic-ai",
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "flex-shrink-0 border border-slate-300 text-slate-900 hover:bg-slate-50 px-6 py-3 text-sm font-semibold rounded transition-colors whitespace-nowrap",
                                children: "See Agentic AI Services"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-slate-50 py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-7xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-12",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "Governance & risk"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-3",
                                    children: "AI governance, addressed from day one."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-slate-600 text-base max-w-2xl",
                                    children: "Governance is scoped to risk, not applied uniformly. We document the posture per workflow — not a blanket policy."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "grid grid-cols-1 md:grid-cols-3 gap-8",
                            children: governanceAnchors.map(function(a) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "border border-slate-200 rounded-lg p-6 bg-white",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                            className: "text-sm font-bold text-slate-900 mb-3",
                                            children: a.title
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-sm text-slate-600 leading-relaxed",
                                            children: a.body
                                        })
                                    ]
                                }, a.title);
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "mt-8",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/agentic-ai#regulatory-posture",
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "text-sm font-medium text-slate-900 border-b border-transparent hover:border-slate-900 pb-px transition-colors",
                                    children: "Full regulatory posture detail"
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-20 sm:py-28 px-6",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                            label: "Readiness assessment"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight mb-4",
                            children: "Not sure if you're ready yet?"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-slate-600 text-base leading-relaxed mb-8 max-w-2xl",
                            children: "Take the Agentic AI Readiness Assessment before booking the diagnostic. Six dimensions — data infrastructure, process maturity, technical compatibility, organisational alignment, regulatory posture, and change management — in three minutes. Instant report."
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/tools/agentic-ai-readiness-quiz",
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "inline-block bg-slate-900 text-white hover:bg-slate-800 px-7 py-3.5 text-sm font-semibold rounded tracking-wide transition-colors",
                                children: "Take the assessment"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_homepage_ContactUsHome__WEBPACK_IMPORTED_MODULE_6__["default"], {})
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-20 sm:py-28 px-6 border-t border-slate-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-4xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionEyebrow, {
                                    label: "FAQ"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-3xl sm:text-4xl font-bold text-slate-900 leading-tight",
                                    children: "What CXOs ask before engaging"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqAccordion, {
                            items: faqItems
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-white py-16 px-6 border-t border-slate-100",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "max-w-7xl mx-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-2xl sm:text-3xl font-bold text-slate-900 mb-10",
                            children: "Further reading"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_reusable_BlogSlider__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            blogs: relatedPosts
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_5__["default"], {})
        ]
    });
};
AIStrategyPage.title = "AI Strategy for Business | ITMTB";
AIStrategyPage.desc = "Book an AI strategy session with ITMTB. We help enterprises plan and deploy AI agents — from scoping to production.";
/* harmony default export */ __webpack_exports__["default"] = (AIStrategyPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1608,8657,5675,279,9774,2888,179], function() { return __webpack_exec__(6983); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);